module.exports = __webpack_public_path__ + "img/65_1.2b511207.png";